export enum BOXTYPE_ENUM {
  tasks = 'tasks',
  calendar = 'calendar',
  colleagues = 'colleagues',
  shortcuts = 'shortcuts',
}

export type BoxKey = keyof typeof BOXTYPE_ENUM;

export type BoxRecordTypes = {
  type: BoxKey;
  ariaLabel?: string;
  loading?: boolean;
  error?: string | null;
  headerConfig?: {
    title?: string;
    description?: string;
    links?: { label?: string; url?: string }[];
    add?: () => void;
  };
};
